import React, { useState } from 'react';
import Swal from 'sweetalert2';
import validator from 'validator';
import { Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { LoginWrapper } from './style';
import loginLogo from '../../assets/images/newlog.svg';
import { customBaseUrl, httpPost } from '../../store/http';
import GlassCard from '../../components/premium/GlassCard';
import PremiumButton from '../../components/premium/PremiumButton';
import PremiumInput from '../../components/premium/PremiumInput';

const { Paragraph, Title } = Typography;

export default function ResetPassword() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [pin, setPin] = useState('');

  const handleSubmit = async (e) => {
    if (e) e.preventDefault();
    setLoading(true);

    if (validator.isEmpty(password)) {
      Swal.fire('Oops!', 'Password cannot be empty', 'error');
      setLoading(false);
      return;
    }
    if (!validator.equals(password, confirmPassword)) {
      Swal.fire('Oops!', 'Passwords do not match', 'error');
      setLoading(false);
      return;
    }
    if (validator.isEmpty(pin)) {
      Swal.fire('Oops!', 'OTP cannot be empty', 'error');
      setLoading(false);
      return;
    }

    const postData = {
      loginId: localStorage.getItem('email'),
      newPassword: password,
      confirmPassword: confirmPassword,
      otp: Number(pin),
    };

    try {
      const res = await httpPost(
        `${customBaseUrl.authUrl}/auth/staff/verify-otp-reset-password`,
        postData,
        true
      );

      setLoading(false);
      if (res.success) {
        Swal.fire({
          title: 'Success!',
          text: 'Your password has been reset successfully.',
          icon: 'success',
          confirmButtonColor: 'var(--waya-red)'
        }).then(() => {
          localStorage.removeItem('email');
          navigate('/');
        });
      } else {
        Swal.fire('Oops!', res?.message ?? res?.error?.message ?? "Something went wrong", 'error');
      }
    } catch (error) {
      setLoading(false);
      Swal.fire('Error', 'Something went wrong. Please try again.', 'error');
    }
  };

  return (
    <LoginWrapper>
      <div className="auth-container" style={{ justifyContent: 'center' }}>
        <div className="auth-form-section" style={{ width: '500px' }}>
          <div className="logo-container" style={{ textAlign: 'center', marginBottom: '32px' }}>
            <img src={loginLogo} alt="WayaBank Logo" />
          </div>

          <GlassCard padding="48px" radius="24px">
            <Title level={2} style={{ textAlign: 'center', marginBottom: '12px', fontWeight: 600 }}>
              Reset Password
            </Title>
            <Paragraph style={{ textAlign: 'center', marginBottom: '32px', color: 'var(--text-muted)' }}>
              Set your new password and enter the OTP sent to your phone.
            </Paragraph>

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '20px' }}>
                <PremiumInput.Password
                  placeholder="New Password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
              </div>

              <div style={{ marginBottom: '20px' }}>
                <PremiumInput.Password
                  placeholder="Confirm Password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                />
              </div>

              <div style={{ marginBottom: '32px' }}>
                <PremiumInput
                  placeholder="Enter OTP Code"
                  value={pin}
                  onChange={(e) => setPin(e.target.value)}
                />
              </div>

              <PremiumButton
                type="primary"
                htmlType="submit"
                size="large"
                block
                loading={loading}
                style={{ height: '48px' }}
              >
                Reset Password
              </PremiumButton>

              <div style={{ marginTop: '24px', textAlign: 'center' }}>
                <a href="/login" style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
                  Back to Sign in
                </a>
              </div>
            </form>
          </GlassCard>
        </div>
      </div>
    </LoginWrapper>
  );
}
